import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';

import {
  WS_UPDATE_CALL_MESSAGE_RECEIVED,
  WS_UPDATE_CALL_REASONS_MESSAGE_RECEIVED,
  WS_UPDATE_CLIENT_MESSAGE_RECEIVED,
  WS_UPDATE_NOTE_MESSAGE_RECEIVED,
} from '../../actions/updates';

class CommonChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  public create() {
    return undefined;
  }

  public info() {
    return undefined;
  }

  public update(payload: ISocketMessage): void {
    const { type: payloadType } = payload as any;

    let type;
    switch (payloadType) {
      case 'call':
        type = WS_UPDATE_CALL_MESSAGE_RECEIVED;
        break;
      case 'call_reasons':
        type = WS_UPDATE_CALL_REASONS_MESSAGE_RECEIVED;
        break;
      case 'client':
        type = WS_UPDATE_CLIENT_MESSAGE_RECEIVED;
        break;
      case 'note':
        type = WS_UPDATE_NOTE_MESSAGE_RECEIVED;
        break;
      // case 'order': no handler for
      default:
        break;
    }

    if (!type) return;

    this.socketChannel.put({
      type,
      payload,
    });
  }

  public delete() {
    return undefined;
  }
}

export default CommonChannelHandler;
